import React, { useEffect } from 'react';
import { MathJax } from 'better-react-mathjax';
import DOMPurify from 'dompurify';
import Loader from '../MUIS/loader';
import { RESPONSE_ICON } from '../../common/images-svg';
import { AMIL_ICON } from '../../common/images-s3';
import ImageLoader from '../../common/image-loader';

const ChatMessages = ({ messages, isBotTyping, isShowButton, paymentProceed, chatContainerRef }) => {
    const messagesEndRef = React.useRef(null);

    useEffect(() => {
        const container = chatContainerRef.current;
        if (!container) return;
    
        const observer = new MutationObserver(() => {
                container.scrollTo({
                top: container.scrollHeight,
                    behavior: 'smooth',
            });
        });
    
        observer.observe(container, {
            childList: true,
            subtree: true,
            characterData: true,
        });
    
        return () => observer.disconnect();
    }, [messages.current]);

    const sanitizeHTML = (html) => {
        if (typeof html !== 'string') return '';

        // First pass: Clean HTML
        let cleanHtml = DOMPurify.sanitize(html, {
            ALLOWED_TAGS: ['b', 'i', 'strong', 'em', 'p', 'br', 'div', 'span', 'math',
                'table', 'thead', 'tbody', 'tr', 'th', 'td', 'h1', 'h2', 'h3'],
            ALLOWED_ATTR: ['class', 'style', 'id'],
            FORBID_ATTR: ['onclick', 'onerror', 'onload'],
        });

        return cleanHtml;
    };

    return (
        <div className="chat-container" id="chat-scroll-container" ref={chatContainerRef}>
            <div className="chat-block">
                {messages.current.map((msg, i) => (
                    <div key={i} className={`${msg.sender === 'user' ?  '' : 'left-msg'}`}>
                        <div className={`msg-list ${msg.sender === 'user' ? 'ai-msg' : 'user-msg'} ${isBotTyping && msg.sender !== 'user' && "msg-type-start"}`}>
                        <span className='amil_icon'>{msg.sender === 'user' ?  '' : 
                        // RESPONSE_ICON
                          <ImageLoader type='image' src={AMIL_ICON} />                        
                        }</span>
                            <div className={`${msg.sender === 'user' ? 'text-left' : 'text-left'}`}>
                                {msg.text && (
                                    <>
                                    <MathJax>
                                            <div
                                                className="msg-text"
                                                dangerouslySetInnerHTML={{
                                                    __html: sanitizeHTML(msg.text),
                                                }}
                                            />
                                    </MathJax> 
                                    </>
                                    
                                )}
                               
                                {msg.file && (
                                    <div className="msg-file">
                                        {Array.isArray(msg.file) ? (
                                            msg.file.map((f, idx) => (
                                                <div key={idx}>{f?.name || f?.path}</div>
                                            ))
                                        ) : (
                                            <div>{msg.file?.name || msg.file?.path}</div>
                                        )}
                                    </div>
                                )}
                                 {isBotTyping && msg.sender !== 'user' && (<div className="msg-lists bot-typing">
                                    <div className="chatBot-typing"><Loader /></div></div>)}
                            </div>
                        </div>
                            {/* {isBotTyping && msg.sender !== 'user' && (<div className="msg-list bot-typing">
                             <div className="chatBot-typing"><Loader /></div></div>)} */}
                        <div ref={messagesEndRef} />
                    </div>
                
                ))}
              
                {isShowButton && (
                    <div className='toPay-btn'>
                        <button onClick={paymentProceed}>Proceed To Pay</button>
                    </div>
                )}
                
            </div>
            
        </div>
    );
};

export default ChatMessages;